import { render, staticRenderFns } from "./TrainingPlanItemNotesPlaceholder.vue?vue&type=template&id=ed2d8cfa&scoped=true&"
import script from "./TrainingPlanItemNotesPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemNotesPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemNotesPlaceholder.vue?vue&type=style&index=0&id=ed2d8cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2d8cfa",
  null
  
)

export default component.exports